<div class="modal-header">
  <h4 class="modal-title"> {{'changeProjectOptionDefPopup.title' | translate}} </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p>{{'changeProjectOptionDefPopup.message' | translate}}</p>
    <div>
      <tabset #tabset>
        <tab>
          <ng-template tabHeading>
            <strong>{{'changeProjectOptionDefPopup.label.fsf' | translate}}</strong>
          </ng-template>
          <table class="table table-striped table-hover" fixedHeader>
            <thead>
            <tr>
              <th width="10%">{{'changeProjectOptionDefPopup.label_identifier' | translate}}</th>
              <th width="45%">{{'changeProjectOptionDefPopup.label_optionName' | translate}}</th>
              <th width="30%">{{'changeProjectOptionDefPopup.label_defaultValue' | translate}}</th>
              <th width="8%">{{'changeProjectOptionDefPopup.label_visible' | translate}}</th>
              <th width="7%"></th>
            </tr>
            </thead>
          </table>
          <div>
            <table class="table table-striped table-hover">
              <tbody minRowCount>
              <tr *ngFor="let row of projectOptionContainer.fsfOptions">
                <td width="10%" class="break-all">{{row.identifier}}</td>
                <td width="45%" class="break-all">{{row.displayName}}</td>
                <td width="30%" class="break-all">{{row.defaultValue}}</td>
                <td width="8%">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="row.isVisible" [id]="'checkbox' + row.identifier" [disabled]="row.isRequired">
                    <label class="form-check-label" [for]="'checkbox' + row.identifier"></label>
                  </div>
                </td>
                <td width="7%">
                  <a  (click)="openEdit(row)" *ngIf="isEditAllowed(row)"><app-svg-icon type="edit-pen"/></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </tab>
        <tab [active]="true">
          <ng-template tabHeading>
            <strong>{{'changeProjectOptionDefPopup.label.general' | translate}}</strong>
          </ng-template>
          <table class="table table-striped table-hover" fixedHeader>
            <thead>
            <tr>
              <th width="10%">{{'changeProjectOptionDefPopup.label_identifier' | translate}}</th>
              <th width="45%">{{'changeProjectOptionDefPopup.label_optionName' | translate}}</th>
              <th width="30%">{{'changeProjectOptionDefPopup.label_defaultValue' | translate}}</th>
              <th width="8%">{{'changeProjectOptionDefPopup.label_visible' | translate}}</th>
              <th width="7%"></th>
            </tr>
            </thead>
          </table>
          <div>
            <table class="table table-striped table-hover">
              <tbody minRowCount>
              <tr *ngFor="let row of projectOptionContainer.generalOptions">
                <td width="10%" class="break-all">{{row.identifier}}</td>
                <td width="45%" class="break-all">{{row.displayName}}</td>
                <td width="30%" class="break-all">{{row.defaultValue}}</td>
                <td width="8%">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="row.isVisible" [id]="'checkbox' + row.identifier" [disabled]="row.isRequired">
                    <label class="form-check-label" [for]="'checkbox' + row.identifier"></label>
                  </div>
                </td>
                <td width="7%">
                  <a  (click)="openEdit(row)" *ngIf="isEditAllowed(row)"><app-svg-icon type="edit-pen"/></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </tab>
        <tab *ngIf="includeInternalOptions" class="flex-column w-100">
          <ng-template tabHeading>
            <strong>{{'changeProjectOptionDefPopup.label.internal' | translate}}</strong>
          </ng-template>
          <table class="table table-striped table-hover" fixedHeader>
            <thead>
            <tr>
              <th width="10%">{{'changeProjectOptionDefPopup.label_identifier' | translate}}</th>
              <th width="45%">{{'changeProjectOptionDefPopup.label_optionName' | translate}}</th>
              <th width="30%">{{'changeProjectOptionDefPopup.label_defaultValue' | translate}}</th>
              <th width="8%">{{'changeProjectOptionDefPopup.label_visible' | translate}}</th>
              <th width="7%"></th>
            </tr>
            </thead>
          </table>
          <div maxHeightOffset="345">
            <table class="table table-striped table-hover">
              <tbody minRowCount>
              <tr *ngFor="let row of projectOptionContainer.internalOptions">
                <td width="10%" class="break-all">{{row.identifier}}</td>
                <td width="45%" class="break-all">{{row.displayName}}</td>
                <td width="30%" class="break-all">{{row.defaultValue}}</td>
                <td width="8%">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="row.isVisible" [id]="'checkbox' + row.identifier" [disabled]="row.isRequired">
                    <label class="form-check-label" [for]="'checkbox' + row.identifier"></label>
                  </div>
                </td>
                <td width="7%">
                  <a  (click)="openEdit(row)" *ngIf="isEditAllowed(row)"><app-svg-icon type="edit-pen"/></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </tab>
      </tabset>
    </div>
    <div class="edit-links small pt-3 ps-3">
      <a class="link" (click)="openLanguageDialog()">
        <i class="mdi mdi-translate"></i>  {{'changeProjectOptionDefPopup.label_select_language' | translate}}
      </a>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="editNotice()">
    {{'changeProjectOptionDefPopup.label.edit_confidential_text' | translate}}
  </button>
  <button type="button" class="btn btn-secondary btn-cancel" (click)="onCancel()">
    {{'global.label.cancel' | translate }}
  </button>
  <button type="submit" class="btn btn-primary btn-forward" (click)="onSave()">
    {{'global.label.save' | translate}}
  </button>
</div>
